import { createFileRoute } from '@tanstack/react-router';

import { RfqCreateQuotePage } from '../rfq/quote/RfqCreateQuotePage';

export const Route = createFileRoute('/_app/requests-for-quotes/$id_/quote')({
    component: RfqCreateQuotePage,
});
